import PropTypes from 'prop-types';

import { selectionShape } from '../Select/index.shape';

export const fieldShape = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const paramShape = {
  operations: PropTypes.arrayOf(
    PropTypes.shape({
      constant: PropTypes.number,
      operator: PropTypes.string,
    })
  ),
  format: PropTypes.shape({
    type: PropTypes.string.isRequired,
    locales: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    currency: PropTypes.string,
    data: PropTypes.string,
  }),
  min: PropTypes.string,
  max: PropTypes.string,
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  selection: PropTypes.arrayOf(selectionShape),
};
